import { Tooltip } from 'bootstrap';
import React, { RefObject, useContext, useEffect, useRef, useState } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import useManagementDashboard from './useManagementDashboard';
import ManagementDashboardService from './ManagementDashboardService';
import * as XLSX from 'xlsx';
import { axiosClient } from '../../../../library/Service/axiosClient';
import moment from 'moment';

const DashboardAccordionItem = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const config: any = ManagementDashboardService.config[props.reportKey];
    const { batches,programs, campuses } = state.data;
    const [expanded, setExpanded] = useState(false);
    const { setStateValue } = useManagementDashboard();
    const [selectedCampuses, setSelectedCampuses] = useState<string[]>([]);
    const [selectedBatches, setSelectedBatches] = useState<string[]>([]);
    const [selectedPrograms, setSelectedPrograms] = useState<string[]>([]);
    const [showViewReportBtn, setShowViewReportBtn] = useState<boolean>(false);
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const divRef = useRef<HTMLDivElement>(null);
    const [primaryColor, setPrimaryColor] = useState('#ff0000'); // Default to red
    const [secondaryColor, setSecondaryColor] = useState('#ffffff'); // Default to white

    const reportBatch = ManagementDashboardService.getBatchesForSelectedTab(state.data.searchCriteria[config.key].userTypeCode,state.data.batches);
    const reportProgram = ManagementDashboardService.getProgramsForSelectedTab(state.data.searchCriteria[config.key].userTypeCode,state.data.programs);
    const reportCampuses = ManagementDashboardService.getCampusForSelectedTab(state.data, config);

    const setDownloadCriteria = (criteriaKey: string, value: any) => {
        handleSelectionChange(criteriaKey, value);
    };

    const handleCampusSelection = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
        const campusValue = event.currentTarget.value;
        if (campusValue === 'ALL') {
            let campus_arr: any = [];
            if (event.currentTarget.checked) {
                reportCampuses.forEach((item: any) => {
                    campus_arr.push(item.value);
                });
            }
            setSelectedCampuses(campus_arr);
            handleSelectionChange(`searchCriteria.${config.key}.campus`, campus_arr.join(','));
            return;
        }
        setSelectedCampuses((prevSelectedCampuses) => {
            const updatedSelectedCampuses = prevSelectedCampuses.includes(campusValue)
                ? prevSelectedCampuses.filter((campus: string) => campus !== campusValue)
                : [...prevSelectedCampuses, campusValue];

            handleSelectionChange(`searchCriteria.${config.key}.campus`, updatedSelectedCampuses.join(','));

            return updatedSelectedCampuses;
        });
    };

    const handleBatchSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
        const batchValue = event.currentTarget.value;
        if (batchValue === 'ALL') {
            let batch_arr: any = [];
            if (event.currentTarget.checked) {
                reportBatch.forEach((item: any) => {
                    batch_arr.push(''+item.value);
                });
            }
            setSelectedBatches(batch_arr);
            handleSelectionChange(`searchCriteria.${config.key}.batch`, batch_arr.join(','));
            return;
        }
        else
        {
            const selectedBatchesNew = selectedBatches.includes(batchValue) ? selectedBatches.filter((batch) => batch != batchValue) : [...selectedBatches, batchValue];
            setSelectedBatches(selectedBatchesNew);
            handleSelectionChange(`searchCriteria.${config.key}.batch`, selectedBatchesNew.join(','));
        }
    };

    const handleProgramSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
        const programValue = event.currentTarget.value;
        if (programValue === 'ALL') {
            let program_arr: any = [];
            if (event.currentTarget.checked) {
                reportProgram.forEach((item: any) => {
                    program_arr.push(''+item.value);
                });
            }
            setSelectedPrograms(program_arr);
            handleSelectionChange(`searchCriteria.${config.key}.program`, program_arr.join(','));
            return;
        }
        else
        {
            const selectedProgramsNew = selectedPrograms.includes(programValue) ? selectedPrograms.filter((program) => program != programValue) : [...selectedPrograms, programValue];
            setSelectedPrograms(selectedProgramsNew);
            handleSelectionChange(`searchCriteria.${config.key}.program`, selectedProgramsNew.join(','));
        }
    };

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef: RefObject<HTMLDivElement> = useRef(null);
    const handleOutsideClick = (event: any) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    const [isBatchOpen, setIsBatchOpen] = useState(false);
    const dropdownBatchRef: RefObject<HTMLDivElement> = useRef(null);
    const handleBatchOutsideClick = (event: any) => {
        if (dropdownBatchRef.current && !dropdownBatchRef.current.contains(event.target)) {
            setIsBatchOpen(false);
        }
    };

    const [isProgramOpen, setIsProgramOpen] = useState(false);
    const dropdownProgramRef: RefObject<HTMLDivElement> = useRef(null);
    const handleProgramOutsideClick = (event: any) => {
        if (dropdownProgramRef.current && !dropdownProgramRef.current.contains(event.target)) {
            setIsProgramOpen(false);
        }
    };
    const tooltipTxt = props.tooltipTxt ?? '';

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('click', handleBatchOutsideClick);
        document.addEventListener('click', handleProgramOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('click', handleBatchOutsideClick);
            document.removeEventListener('click', handleProgramOutsideClick);
        };
    }, []);

    const handleSelectionChange = (dataKey: string, value: string) => setStateValue(dataKey, value);

    const handleDownloadImage = async (width: number, height: number, filename: string) => {
        if (!divRef.current) {
            console.error('Element not found!');
            return;
        }
    
        const images = Array.from(divRef.current.querySelectorAll('img')) as HTMLImageElement[];
    
        // Select buttons and anchors to hide
        const elementsToHide = divRef.current.querySelectorAll('.download-btn, .icon-info');
        const originalDisplayStyles: string[] = [];
    
        try {
            // Hide buttons and anchors
            elementsToHide.forEach((el, index) => {
                originalDisplayStyles[index] = (el as HTMLElement).style.display;
                (el as HTMLElement).style.display = 'none';
            });
    
            // Wait for all images to load
            await Promise.all(
                images.map((img) => {
                    return new Promise<void>((resolve, reject) => {
                        if (img.complete && img.naturalWidth > 0) {
                            resolve();
                        } else {
                            img.onload = () => resolve();
                            img.onerror = () => reject(new Error(`Failed to load image: ${img.src}`));
                            setTimeout(() => reject(new Error(`Image load timeout: ${img.src}`)), 10000);
                        }
                    });
                })
            );
    
            const { default: html2canvas } = await import('html2canvas');
    
            const canvas = await html2canvas(divRef.current, {
                backgroundColor: secondaryColor,
                scale: 2,
                useCORS: true,
                allowTaint: false,
                logging: false,
                imageTimeout: 10000,
                removeContainer: true,
                foreignObjectRendering: false,
            });
    
            const scaledCanvas = document.createElement('canvas');
            scaledCanvas.width = width;
            scaledCanvas.height = height;
    
            const ctx = scaledCanvas.getContext('2d', {
                willReadFrequently: true,
                alpha: true
            });
    
            if (ctx) {
                ctx.fillStyle = secondaryColor;
                ctx.fillRect(0, 0, width, height);
    
                const sourceAspect = canvas.width / canvas.height;
                const targetAspect = width / height;
    
                let drawWidth = width;
                let drawHeight = height;
                let offsetX = 0;
                let offsetY = 0;
    
                if (sourceAspect > targetAspect) {
                    drawHeight = width / sourceAspect;
                    offsetY = (height - drawHeight) / 2;
                } else {
                    drawWidth = height * sourceAspect;
                    offsetX = (width - drawWidth) / 2;
                }
    
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';
    
                ctx.drawImage(canvas, offsetX, offsetY, drawWidth, drawHeight);
    
                scaledCanvas.toBlob((blob) => {
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = filename;
    
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
    
                        URL.revokeObjectURL(url);
                    } else {
                        console.error('Failed to create blob from canvas');
                    }
                }, 'image/png', 0.95);
            }
    
            canvas.width = 1;
            canvas.height = 1;
        } catch (error) {
            console.error('Error generating image:', error);
            throw new Error(`Failed to download image: ${error instanceof Error ? error.message : 'Unknown error'}`);
        } finally {
            // Restore hidden elements
            elementsToHide.forEach((el, index) => {
                (el as HTMLElement).style.display = originalDisplayStyles[index];
            });
        }
    };
    

    useEffect(() => {
        // Update individual accordion state based on the global accordion state
        setExpanded(state.data.accordionState === 'EXPANDED');
    }, [state.data.accordionState]);

    useEffect(() => {
        setStateValue(`searchCriteria.${config.key}.batch`, '');
        setStateValue(`searchCriteria.${config.key}.program`, '');
        setStateValue(`searchCriteria.${config.key}.campus`, '');
        setSelectedBatches([]);
        setSelectedPrograms([]);
        setSelectedCampuses([]);
    }, [state?.data?.searchCriteria?.[config.key]?.userTypeCode]);

    useEffect(() => {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    useEffect(() => {
        const isDataPresentInTopBatches = state?.data?.reportData?.topbatches?.some((batch: any) =>
            Object.values(batch)
              .filter(value => typeof value === 'object' && value !== null && 'value' in value)
              .some((item:any) => Number(item.value) > 0)
        );

        if(props.reportKey.toLowerCase() == 'onboarding' && state.data?.reportData?.onboarding?.['Total Accounts Created'] > 0) {
            setShowViewReportBtn(true);
        }
        else if(props.reportKey.toLowerCase() == 'topbatches' && isDataPresentInTopBatches) {
            setShowViewReportBtn(true);
        }
        else if(props.reportKey.toLowerCase() == 'occupation' && state.data?.reportData?.alumniPresentStatus?.length > 0) {
            setShowViewReportBtn(true);
        }
        else if(props.reportKey.toLowerCase() == 'country' && state.data?.reportData?.alumniCountry?.length > 0) {
            setShowViewReportBtn(true);
        }
        else{
            setShowViewReportBtn(false);
        }
    }, [state.data?.reportData]);

    const getCsvDownloadData = async (key:string) => {
            const payload = { ...state.data.searchCriteria?.[key] };
            
            // call the API to download the CSV
            let response = await axiosClient().post(`${process.env.REACT_APP_STUDENT_MANAGEMENT_SERVER}/csv-download/${key}`, payload);
            return response.data;
        };

    function extractData(data: any[] = []) {
        if (!Array.isArray(data) || data.length === 0) {
          return { gridData: [], columnHeaders: [] };
        }
      
        const columnHeaders = Object.keys(data[0]);
        const gridData = data;
      
        return { gridData, columnHeaders };
      }      

    const handleExport = async (key: string) => {
            setIsDownloading(true);
            const freshData = await getCsvDownloadData(key);
            const { gridData, columnHeaders } = extractData(freshData);

            const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });
            XLSX.utils.sheet_add_aoa(worksheet, [columnHeaders]);
            XLSX.utils.sheet_add_json(worksheet, gridData, { origin: 'A2', skipHeader: true });

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            let downloadFileName = key+moment().format('DD/MM/YYYY HH:mm:ss');

            XLSX.writeFile(workbook, `${downloadFileName}.xlsx`);
            setIsDownloading(false);
    };

    return (
        <div className="accordion-item" ref={divRef}>
            <h2 className="accordion-header" id={`panelsStayOpen-${props.reportKey}`} onClick={() => {setStateValue(props.reportKey.toLowerCase()+'_isOpen' , (!expanded).toString()); setExpanded(!expanded);}}>
                <button
                    className={`accordion-button ${expanded ? 'collapsed' : ''}`}
                    type="button"
                    aria-expanded={expanded}
                    aria-controls={`${props.reportKey}`}>
                    {config.title}
                    <span className="icon-info" title="" data-bs-toggle="tooltip" data-bs-original-title={tooltipTxt} aria-label=""></span>
                </button>
            </h2>
            <div
                id={`item-${props.reportKey}`}
                className={`accordion-collapse collapse ${expanded ? 'show' : ''}`}
                aria-labelledby={`item-${props.reportKey}`}>
                <div className="accordion-body">
                    <div className="d-flex flex-wrap flex-1 mb-4">
                        {config.filters.includes('userTypeCode') && (
                            <select
                                key={`${props.reportKey}-userTypeCode`}
                                onChange={(event) => handleSelectionChange(`searchCriteria.${config.key}.userTypeCode`, event.target.value)}
                                className="form-select onboarding me-2"
                                aria-label="Default select example">
                                <option key={'ALUMNI'} value={'ALUMNI'}>
                                    {'Alumni'}
                                </option>
                                <option key={'STUDENT'} value={'STUDENT'}>
                                    {'Student'}
                                </option>
                            </select>
                        )}

                        {config.filters.includes('batch') && (
                            
                            <div className={`dropdown me-2 ${isBatchOpen ? 'open' : ''}`} ref={dropdownBatchRef}>
                                <button className="filter-custom-select dashboard-filter" type="button" onClick={() => setIsBatchOpen(!isBatchOpen)}>
                                    {selectedBatches.length > 0
                                        ? selectedBatches
                                              .map((selectedBatch) => batches.find((item: any) => item.value == selectedBatch)?.label)
                                              .join(', ')
                                        : 'Select Batch'}
                                </button>
                                <div className="dropdown-menu" style={{ display: isBatchOpen ? 'block' : 'none', background: 'white' }}>
                                    <div className="dropdown-wrap">
                                        <div key={`all-domain-select-batch`} className="dropdown-item">
                                            <input
                                                type="checkbox"
                                                id={`${props.reportKey}-allBatch`}
                                                className="form-check-input me-1"
                                                checked={selectedBatches.length === reportBatch.length}
                                                onChange={handleBatchSelection}
                                                value="ALL"
                                                
                                            />
                                            <label htmlFor={`${props.reportKey}-allBatch`} className="form-check-label">
                                                All Batches
                                            </label>
                                        </div>
                                        {reportBatch.map((item: { value: string; label: string }) => (
                                            <div key={item.value} className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    id={`${props.reportKey}-Batch-${item.value}`}
                                                    className="form-check-input me-1"
                                                    checked={selectedBatches.includes(''+item.value)}
                                                    onChange={handleBatchSelection}
                                                    value={item.value}
                                                />
                                                <label htmlFor={`${props.reportKey}-batch-${item.value}`} className="form-check-label">
                                                    {item.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        {config.filters.includes('programName') && (
                            
                            <div className={`dropdown me-2 ${isProgramOpen ? 'open' : ''}`} ref={dropdownProgramRef}>
                                <button className="filter-custom-select dashboard-filter" type="button" onClick={() => setIsProgramOpen(!isProgramOpen)}>
                                    {selectedPrograms.length > 0
                                        ? selectedPrograms
                                              .map((selectedProgram:any) => programs.find((item: any) => item.value == selectedProgram)?.label)
                                              .join(', ')
                                        : 'Select Program'}
                                </button>
                                <div className="dropdown-menu" style={{ display: isProgramOpen ? 'block' : 'none', background: 'white' }}>
                                    <div className="dropdown-wrap">
                                        <div key={`all-domain-select-Program`} className="dropdown-item">
                                            <input
                                                type="checkbox"
                                                id={`${props.reportKey}-allProgram`}
                                                className="form-check-input me-1"
                                                checked={selectedPrograms.length === reportProgram.length}
                                                onChange={handleProgramSelection}
                                                value="ALL"
                                            />
                                            <label htmlFor={`${props.reportKey}-allProgram`} className="form-check-label">
                                                All Programs
                                            </label>
                                        </div>
                                        {reportProgram.map((item: { value: string; label: string }) => (
                                            <div key={item.value} className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    id={`${props.reportKey}-Program-${item.value}`}
                                                    className="form-check-input me-1"
                                                    checked={selectedPrograms.includes(''+item.value)}
                                                    onChange={handleProgramSelection}
                                                    value={item.value}
                                                />
                                                <label htmlFor={`${props.reportKey}-Program-${item.value}`} className="form-check-label">
                                                    {item.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* {config.filters.includes('dateRange') && (
                            <select
                                key={`${props.reportKey}-dateRange`}
                                onChange={(event) => handleSelectionChange(`searchCriteria.${config.key}.dateRange`, event.target.value)}
                                className="form-select onboarding me-2"
                                aria-label="Default select example">
                                <option value="">Date</option>
                                {(state?.domain?.get('MGMT_DASH_DATE_RANGE') as any).map((item: any) => (
                                    <option key={item.code} value={item.code}>
                                        {item.value}
                                    </option>
                                ))}
                            </select>
                        )} */}

                        {config.filters.includes('campus') && campuses.length > 0 && (
                            // <select
                            //     key={`${props.reportKey}-campus`}
                            //     onChange={(event) => handleSelectionChange(`searchCriteria.${config.key}.campus`, event.target.value)}
                            //     className="form-select onboarding me-2"
                            //     aria-label="Default select example">
                            //     <option value="">Campus</option>
                            //     {campuses.map((item: any) => (
                            //         <option key={item.value} value={item.value}>
                            //             {item.label}
                            //         </option>
                            //     ))}
                            // </select>

                            <div className={`dropdown ${isOpen ? 'open' : ''}`} ref={dropdownRef}>
                                {/* <label htmlFor={`campus-label`} className="form-label w-100">
                                    Select Campus
                                </label> */}
                                <button className="filter-custom-select dashboard-filter" type="button" onClick={() => setIsOpen(!isOpen)}>
                                    {selectedCampuses.length > 0
                                        ? selectedCampuses
                                              .map((selectedCampus) => campuses.find((item: any) => item.value === selectedCampus)?.label)
                                              .join(', ')
                                        : 'Select Campus'}
                                </button>
                                <div className="dropdown-menu" style={{ display: isOpen ? 'block' : 'none', background: 'white' }}>
                                    <div className="dropdown-wrap">
                                        <div key={`all-domain-select`} className="dropdown-item">
                                            <input
                                                type="checkbox"
                                                id={`${props.reportKey}-allCampus`}
                                                className="form-check-input me-1"
                                                checked={selectedCampuses.length === campuses.length}
                                                onClick={handleCampusSelection}
                                                value="ALL"
                                                onChange={() =>
                                                    setSelectedCampuses(
                                                        selectedCampuses.length === campuses.length
                                                            ? []
                                                            : campuses.map((item: any) => item.value)
                                                    )
                                                }
                                            />
                                            <label htmlFor={`${props.reportKey}-allCampus`} className="form-check-label">
                                                All Campuses
                                            </label>
                                        </div>
                                        {reportCampuses.map((item: { value: string; label: string }) => (
                                            <div key={item.value} className="dropdown-item">
                                                <input
                                                    type="checkbox"
                                                    id={`${props.reportKey}-campus-${item.value}`}
                                                    className="form-check-input me-1"
                                                    checked={selectedCampuses.includes(item.value)}
                                                    onClick={handleCampusSelection}
                                                    value={item.value}
                                                />
                                                <label htmlFor={`${props.reportKey}-campus-${item.value}`} className="form-check-label">
                                                    {item.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="row g-4">
                        <div className="col-md-12">
                            <div id="stdonboardgraph">
                                <div className="d-block text-center">{props.children}</div>
                            </div>
                        </div>
                        <div className="col-12 download-btn">
                            <div className="row g-2 align-items-center">
                                <div className="col">
                                    {showViewReportBtn && <button
                                        // onClick={() => setDownloadCriteria('downloadCriteria.studentOnboardingCsv', '1')}
                                        onClick={() => handleExport(props.reportKey.toLowerCase())}
                                        className="btn-green mx-auto mt-3">
                                        {isDownloading ? 
                                        <div className="spinner-border" style={{height:'20px',width:'20px'}} role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div> 
                                        : <span>View Report</span>}
                                    </button>}
                                </div>
                                {showViewReportBtn && <div className="col-auto">
                                    <a onClick={() => handleDownloadImage(900, 700, props.reportKey.toLowerCase() + '.jpg')} className="">
                                        <img src="https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/icon-download.svg" alt="" />
                                    </a>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardAccordionItem;
